import { render, staticRenderFns } from "./TransferOrder.vue?vue&type=template&id=f22fb10a&scoped=true&"
import script from "./TransferOrder.vue?vue&type=script&lang=js&"
export * from "./TransferOrder.vue?vue&type=script&lang=js&"
import style0 from "./TransferOrder.vue?vue&type=style&index=0&id=f22fb10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22fb10a",
  null
  
)

export default component.exports